/* eslint-disable */

import axios from 'axios';
import LocalStorage from '@/services/localstorage';


let pgwAPI = null;
const PgwAPIService = {
  init(url) {
    let token = LocalStorage.getUserToken()
    pgwAPI = axios.create({
      baseURL: url,
      timeout: 60000,
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  post(resource, data) {
    return pgwAPI.post(resource, data);
  },
  get(resource, data) {
    return pgwAPI.get(resource, data);
  },
};

export default PgwAPIService;
